<div class="min-h-screen bg-slate-50 px-4 sm:px-6 lg:px-8">
  <main class="mx-auto max-w-2xl">
    <div [@typeformTransition]="surveyRenderStore.renderState()">
      @switch (surveyRenderStore.renderState()) { @case
      (RENDER_STATES.INITIALIZING) {
      <lib-survey-initialsing></lib-survey-initialsing>

      } @case (RENDER_STATES.LOADING) {
      <lib-survey-loading></lib-survey-loading>

      } @case (RENDER_STATES.LOGIN) {
      <lib-survey-login></lib-survey-login>
      } @case (RENDER_STATES.EXPIRED) {
      <lib-survey-expired></lib-survey-expired>

      } @case (RENDER_STATES.COMPLETED) {
      <lib-survey-completed></lib-survey-completed>

      } @case (RENDER_STATES.ERROR_OCCURED) {
      <lib-survey-error-occured></lib-survey-error-occured>

      } @case (RENDER_STATES.PAGE) {
      <lib-survey-page></lib-survey-page>
      } @case (RENDER_STATES.END) {
      <lib-survey-completed></lib-survey-completed>
      } }
    </div>
  </main>
</div>
